<template>
  <div>
    <b-card no-header>
      <form>
        <app-cliente
          label="Cliente"
          :nombre="clienteNombre"
          :labelCols="labelCols"
          :valido="clienteValido"
          :lista="clientesList"
          :msjInvalido="clienteInvalidoMsj"
          :readOnly="!seleccionarCliente"
          @validate="validate"
          @updated="clienteActualizado">
        </app-cliente>  

        <b-form-group
          label="Acción"
          label-for="accion"
          :labelCols="labelCols"
          horizontal>
          <b-form-input 
            id="accion"
            v-model.trim= "$v.accion.$model" 
            :state="accionValida"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="accionFeedback">
            {{ accionInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <app-cliente-contacto
          label="Contacto"
          :nombre="clienteContactoNombre"
          :labelCols="labelCols"
          :valido="clienteContactoValido"
          :lista="clientesContactosList"
          :msjInvalido="clienteContactoInvalidoMsj"
          :nullDisabled="Boolean(false)"
          @validate="validate"
          @updated="clienteContactoActualizado">
          <div class="custom-select-add"
              @click.prevent="addContacto">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </div>
        </app-cliente-contacto>

        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="parametrosActualizados"
              v-model="parametrosActualizados"
              value= true
              unchecked-value= false>
              Actualizar parámetros generales
          </b-form-checkbox>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Duplicar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelarDuplicado">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>

    <b-modal ref="contactoModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-alta-contacto
        :cliente="cliente"
        :modal="Boolean(true)" 
        @updateContactos="updateContactos"
        @closeContacto="closeContacto">
      </app-alta-contacto>  
    </b-modal>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import Cliente from '../shared/abmSelect.vue';
import ClienteContacto from '../shared/abmSelect.vue';
import AltaContacto from '../clientescontactos/ABM.vue';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'Duplicado',
  props: {
    clientePresupuesto: {
      type: Object,
      default: null,
    }
  },
  components: {
    appCliente: Cliente,
    appClienteContacto: ClienteContacto,
    appAltaContacto: AltaContacto,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      cliente: null,
      accion: '',
      clienteContacto: null,
      parametrosActualizados: false,

      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      accionValida: null,
      accionInvalidaMsj: '',
      clienteContactoValido: null,
      clienteContactoInvalidoMsj: '',

      clientes: [],
      clientesList: [],
      clientesContactos: [],
      clientesContactosList: [],

      labelCols: 2,
      loadingClientes: false,
      seleccionarCliente: true,
    }
  },
  computed: {
    clienteId() {
      if (this.cliente) {
        if (this.cliente.id) {
          return this.cliente.id;
        }
      }
      return 0;
    },
    clienteNombre() {
      if (this.cliente) {
        if (this.cliente.nombre) {
          return this.cliente.nombre.trim();
        }
      }
      return null;
    },
    clienteContactoNombre() {
      if (this.clienteContacto) {
        if (this.clienteContacto.nombre) {
          return this.clienteContacto.nombre.trim();
        }
      }
      return null;
    },
    clienteContactoId() {
      if (this.clienteContacto) {
        if (this.clienteContacto.id) {
          return this.clienteContacto.id;
        }
      }
      return 0;
    },
  },
  created() {
    if (this.clientePresupuesto) {
      this.cliente = this.clientePresupuesto;
      this.seleccionarCliente = false;
    }

    if (this.cliente) {
      this.getContactos();
    } else {
      this.getClientes();
    }
  },  
  methods: {
    getClientes() {
      let vm = this;

      vm.loadingClientes = true;
      vm.$store.dispatch('clientes/getList')
        .then(() => {
          vm.clientes = this.$store.getters['clientes/list'];
          vm.clientesList = this.$store.getters['clientes/selectList'];
          this.loadingClientes= false;
          return;
        })
        .then (() => {
          vm.getContactos();
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de clientes.'));
    },
    getContactos(clienteContactoNombre) {
      this.clientesContactos = [];
      this.clientesContactosList = [];

      if (this.clienteId)
      {
        if (this.clienteId != 0) {
          this.$store.dispatch('clientescontactos/getClientesContactosList', this.clienteId)
            .then(() => {
              this.clientesContactos = this.$store.getters['clientescontactos/contactosList'];
              this.clientesContactosList = this.$store.getters['clientescontactos/contactosSelectList'];
              return;
            })
            .then(() => {
              if (clienteContactoNombre) {
                this.clienteContacto = this.getSelected(this.clientesContactos, clienteContactoNombre);
              }
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de contactos del cliente.'));
        }
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'accion' || validarTodos) {
        if (this.$v.accion.$error) {
          this.accionValida = false;
          if (!this.$v.accion.required) {
            this.accionInvalidaMsj= 'Debe ingresar el nombre de la acción.';
          } else if (!this.$v.accion.maxLength) {
            this.accionInvalidaMsj = 'El nombre de la acción solo puede contener hasta 50 caracteres';
          }      
        } else {
          this.accionValida = null;
          this.accionInvalidaMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      let save = Boolean(false);
      let errorCliente = Boolean(false);
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            save = Boolean(true);
          }
        }
      }
      if (errorCliente) {
        this.clienteValido = false;
        this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente.';
      }

      // let errorClienteContacto = Boolean(false);
      // if (this.clienteContacto) {
      //   if (this.clienteContacto.id) {
      //     if (this.clienteContacto.id != 0) {
      //       save = Boolean(true);
      //     }
      //   }
      // }
      // if (errorClienteContacto) {
      //   this.clienteContactoValido = false;
      //   this.clienteContactoInvalidoMsj = "Debe seleccionar el contacto correspondiente.";
      // }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            clienteId: this.clienteId,
            accion: this.accion.toUpperCase().trim(),
            clienteContactoId: this.clienteContactoId,
            parametrosActualizados: this.parametrosActualizados
          }
          this.$emit('duplicar', params)
        }
      }
    },
    cancelarDuplicado() {
      this.$emit('cancelarDuplicado')
    },
    clienteActualizado(clienteNombre) {
      if (!this.loadingClientes && this.clienteNombre != clienteNombre) {        
        this.clienteContacto = null;
        this.clientesContactos = [];
        this.clientesContactosList = [];

        this.cliente = null;

        if (clienteNombre) {
          this.cliente = this.getSelected(this.clientes, clienteNombre);
          
          this.clienteValido = null;
          this.clienteInvalidoMsj = '';
        } 

        this.getContactos();
      }
    },
    clienteContactoActualizado(clienteContactoNombre) {
      this.clienteContacto = null;

      if (clienteContactoNombre) {
        this.clienteContacto = this.getSelected(this.clientesContactos, clienteContactoNombre);
        
        this.clienteContactoValido = null;
        this.clienteContactoInvalidoMsj = '';
      } 
    },
    addContacto() {
      let addContacto = false;
      if (this.clienteId) {
        if (this.clienteId != 0) {
          addContacto = true;
        }
      }

      if (addContacto) {
        this.$refs.contactoModal.show();
      } else {
        this.showModalMsj('Seleccione en primer término el cliente correspondiente.', null, null, 'light')
      }      
    },
    updateContactos(contactoNombre) {
      this.$refs.contactoModal.hide()
      this.getContactos(contactoNombre);
    },
    closeContacto() {
      this.$refs.contactoModal.hide()
    },    
  },
  validations: {
    accion: {
      required,
      maxLength: maxLength(50)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
